import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const WarningFilled = createSvgIcon(
  <path d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-10.95 4.55a1.05 1.05 0 1 0-2.1 0 1.05 1.05 0 0 0 2.1 0Zm0-2.45V6.4h-2.1v7.7h2.1Z" />,
  'WarningFilled'
);

export { WarningFilled };